import { inventorySnapshotFields } from './inventoryAvailability.js'
/**
 * @description Normalize cart rows for the header badge and hover popup.
 * Header cart display is independent from the cart page selection state.
 */

const toQuantity = (value) => {
  const n = Math.trunc(Number(value))
  return Number.isFinite(n) && n > 0 ? n : 0
}

const readRows = (source) => {
  if (Array.isArray(source)) return source
  if (!source || typeof source !== 'object') return []
  if (Array.isArray(source.shopCartItems)) return source.shopCartItems
  if (Array.isArray(source.items)) return source.items
  return []
}

const resolveHeaderCartItemId = (item, index) => {
  const id = item?.id ?? item?.basketId ?? item?.shopCartItemId
  if (id != null && id !== '') return String(id)
  const prodId = item?.prodId ?? item?.productVO?.prodId
  const skuId = item?.skuId ?? item?.skuVO?.skuId
  return `${prodId ?? 'prod'}:${skuId ?? 'sku'}:${index}`
}

export const getHeaderCartDisplayItems = (source) =>
  readRows(source).map((item, index) => ({
    ...item,
    ...inventorySnapshotFields(item?.inventoryStatus ? item : item?.skuVO),
    id: resolveHeaderCartItemId(item, index),
    basketId: item?.basketId ?? item?.id,
    prodId: item?.prodId ?? item?.productVO?.prodId,
    skuId: item?.skuId ?? item?.skuVO?.skuId,
    image:
      item?.image ??
      item?.pic ??
      item?.skuPic ??
      item?.productPic ??
      item?.skuVO?.pic ??
      item?.productVO?.pic ??
      '',
    price: item?.price ?? item?.actualPrice ?? item?.skuVO?.price ?? item?.productVO?.price ?? 0,
    quantity: toQuantity(item?.quantity ?? item?.basketCount ?? item?.prodCount ?? item?.count),
  }))

export const sumHeaderCartQuantity = (source) =>
  getHeaderCartDisplayItems(source).reduce((sum, item) => sum + item.quantity, 0)

export const resolveHeaderCartFinalMoney = (cartData) => {
  if (!cartData || typeof cartData !== 'object') return 0
  return cartData.totalFinalAmount ?? cartData.finalMoney ?? cartData.totalMoney ?? 0
}
